import historyIcon from "../../../../assets/icons/jobcardHistory.svg";

const NoHistoryView = ({
  isSucceed,
  dataLength,
  title = "No Job Card History Selected",
  description = "Please select a date and cylinder number to view the job card history.",
  filteredTitle = "No Results Found",
  filteredDescription = "We couldn’t find any job card records for the selected date and cylinder.",
}) => {
  // Default state
  let displayTitle = title;
  let displayDescription = description;

  // After filters are applied but no results
  if (isSucceed && dataLength === 0) {
    displayTitle = filteredTitle;
    displayDescription = filteredDescription;
  }

  return (
    <div className="bg-white mt-1 rounded-lg border-1 border-dBlue-100 flex justify-center items-center h-[calc(100vh-11em)] lg:h-[calc(100vh-13em)] text-gray-800 py-12">
      <div className="text-center">
        <img
          src={historyIcon}
          alt="No History"
          className="lg:max-w-[150px] max-w-[100px] mx-auto"
        />

        <p className="pt-5 lg:text-lg font-figtreeBold">{displayTitle}</p>

        <p className="text-xs lg:text-sm max-w-sm pt-1">{displayDescription}</p>
      </div>
    </div>
  );
};

export default NoHistoryView;
